import { ApiFailure } from "@/lib/api";

/** Текст отказа для человека: у `ApiFailure` он уже человеческий, у сети — нет. */
export function errorText(error: unknown): string {
  if (typeof error === "string") return error; // каталог держит ошибки и подсказки строкой
  if (error instanceof ApiFailure) return error.message;
  if (error instanceof TypeError) return "Сервис не ответил — проверьте сеть и повторите.";
  if (error instanceof Error) return error.message;
  return "Что-то пошло не так.";
}
